// extracted by mini-css-extract-plugin
export default {"itemWord":"ItemWord_itemWord__w8q-1","menu-popper":"ItemWord_menu-popper__74yOR","menu-item":"ItemWord_menu-item__0vba7"};